import { createContext } from 'react';

export const ScalesContext =  createContext ();